/** Shared verdict presentation for threat-intel results. */
export const VERDICT_META = {
  malicious: { label: 'Malicious', color: 'error' },
  suspicious: { label: 'Suspicious', color: 'warning' },
  clean: { label: 'Clean', color: 'success' },
  unknown: { label: 'No data', color: 'default' },
  error: { label: 'Error', color: 'default' },
};

export const verdictMeta = (verdict) => VERDICT_META[verdict] || VERDICT_META.unknown;

export const PROVIDER_ORDER = ['virustotal', 'abuseipdb', 'otx', 'abusech', 'greynoise', 'shodan', 'geoip', 'dns'];

export const sortResults = (results = []) =>
  [...results].sort((a, b) => {
    const rank = (r) => ({ malicious: 0, suspicious: 1, clean: 2, unknown: 3, error: 4 }[r.verdict] ?? 3);
    return rank(a) - rank(b) || PROVIDER_ORDER.indexOf(a.provider) - PROVIDER_ORDER.indexOf(b.provider);
  });
